/**
 * Filtros em pastilhas (RNF15).
 *
 * `FilterChips` e selecao UNICA (produto, oferta, plano): a ativa fica cheia
 * na cor da marca e as demais tem contorno. Diferente das abas, os chips nao
 * trocam a secao da pagina; recortam o dado que ja esta na tela. Para escolha
 * multipla use `Checkbox` de Field.tsx -- chip com varios ativos deixa de
 * comunicar "qual esta selecionado".
 */

export interface ChipOption<T extends string> {
  readonly value: T;
  readonly label: string;
  /** Contador ja formatado, opcional. */
  readonly count?: string;
}

interface FilterChipsProps<T extends string> {
  readonly options: readonly ChipOption<T>[];
  readonly value: T;
  readonly onChange: (value: T) => void;
  readonly label: string;
  /** Texto antes dos chips, por exemplo "Produto:". */
  readonly prefix?: string;
  readonly tone?: 'brand' | 'accent';
}

export function FilterChips<T extends string>({ options, value, onChange, label, prefix, tone = 'brand' }: FilterChipsProps<T>): JSX.Element {
  const ativo = tone === 'brand' ? 'border-brand bg-brand text-white' : 'border-accent bg-accent text-white';
  const inativo = tone === 'brand' ? 'border-brand/40 text-brand hover:bg-brand/10' : 'border-accent/40 text-accent hover:bg-accent/10';
  return (
    <div role="radiogroup" aria-label={label} className="flex flex-wrap items-center gap-2">
      {prefix === undefined ? null : <span className="mr-1 text-xs font-medium text-ink-subtle">{prefix}</span>}
      {options.map((opt) => {
        const selecionado = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selecionado}
            onClick={() => onChange(opt.value)}
            className={`inline-flex h-8 items-center gap-1.5 rounded-full border px-3 text-xs font-medium transition-all duration-150 active:scale-[0.97] ${selecionado ? ativo : inativo}`}
          >
            {opt.label}
            {opt.count === undefined ? null : <span className={`tabular-nums ${selecionado ? 'text-white/80' : 'text-ink-subtle'}`}>{opt.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
